import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import TextField from '@mui/material/TextField';

function EditableText(props) {
  const { initialValue, type, isEditable, onValueChange} = props;
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(initialValue);

  const handleDoubleClick = () => {
    setIsEditing(true && isEditable);
  };

  const handleChange = (event) => {
    setText(event.target.value);
    onValueChange(event);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  return (
      <div onDoubleClick={handleDoubleClick}>
        {isEditing ? (
          <TextField
            autoFocus={true}
            onBlur={handleBlur}
            sx={ type == "number"? {
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                display: "none",
              },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            } : {} }
            defaultValue={initialValue}
            type={type}
            onChange={handleChange}
            size="small" />)
          : (
          <span>{text}</span>
        )}
      </div>
  );
}
EditableText.propTypes = {
  initialValue: PropTypes.any.isRequired,
  type: PropTypes.string.isRequired,
  isEditable: PropTypes.bool.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default EditableText;
